import { ca } from '@cian/analytics';
import { IAgentSchema, IOfferSchema, IUserSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getCustomUrl } from './getCustomUrl';
import { getPage } from './getPage';
import { getPartner } from './getPartner';
import { getUser } from './getUser';
import { getProducts } from './get_products';

interface ITrackShowStatNumber {
  offer: IOfferSchema;
  agent: IAgentSchema | null;
  user: IUserSchema | null;
  clickId: string;
}

/** Деградация динКТ (SEL-998): подменный номер не получен, показана статика */
export function trackShowStatNumber({ offer, agent, user, clickId }: ITrackShowStatNumber) {
  const products = getProducts({ agent, offer, kpId: null });
  const page = getPage(agent, offer);

  ca('eventEbc', {
    action: 'Show_stat_number',
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    page: {
      ...page,
      extra: { ...page.extra, click_id: clickId },
    },
    partner: getPartner(user, offer),
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, 0),
  });
}
